import { Experiments, WidgetSpecs } from '@wix/wix-help-widget-common/experiments';

export const enableNotifications = (experiments: Experiments<WidgetSpecs>) =>
  experiments.enabled('specs.helpwidget.openHelpWidgetFromHeader');
